import type { ReactNode } from "react";
import { ConfigProvider, theme as antdTheme } from "antd";
import type { Locale } from "antd/es/locale";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../store/hooks";

// Глобален antd ConfigProvider: преводи за филтрите на таблиците (BG/EN през i18n),
// за да не са на английски. Бутоните се стилизират в index.css (две 50/50 обикновени).
// Тук се превключва и antd тъмната тема (darkAlgorithm) според store.theme.mode.
export default function ThemedConfig({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const themeMode = useAppSelector((state) => state.theme.mode);
  return (
    <ConfigProvider
      theme={{
        algorithm:
          themeMode === "dark"
            ? antdTheme.darkAlgorithm
            : antdTheme.defaultAlgorithm,
        // Топли повърхности за antd в тъмна тема: базата е платното на
        // приложението, а elevated (модали, dropdown-и, попъпи) е ниво 1 от
        // elevation системата в index.css — иначе antd дава неутрално сиво.
        //
        // `colorPrimary` е ФИРМЕНИЯТ оранжев, не синьото по подразбиране на
        // antd. Без него всяка отметка, radio, активен ред в dropdown и фокус
        // рамка в приложението светваха в #1677ff — цвят, който не съществува
        // никъде другаде в интерфейса. Стойността е същата като `--color-brand`
        // в index.css; antd не разбира `var()` в token математиката си, затова
        // е изписана буквално и на двете места.
        token: {
          colorPrimary: "#D97706",
          colorLink: themeMode === "dark" ? "#f0a640" : "#B45309",
          ...(themeMode === "dark"
            ? {
                colorBgBase: "#171310",
                colorBgContainer: "#231e18",
                colorBgElevated: "#332b22",
                colorBorder: "#453d32",
                colorBorderSecondary: "#38312a",
              }
            : {}),
        },
      }}
      locale={
        {
          Table: {
            filterConfirm: t("inventoryPage.filterApply"),
            filterReset: t("inventoryPage.filterReset"),
            filterSearchPlaceholder: t("inventoryPage.filterSearch"),
            filterCheckAll: t("inventoryPage.filterSelectAll"),
          },
        } as unknown as Locale
      }
    >
      {children}
    </ConfigProvider>
  );
}
